module.exports = __webpack_public_path__ + "img/24.0bd61c31.png";